
import { apiFetch } from './client';
import type { Task } from '../types/contracts';

export const tasksApi = {
  list:       ()                              => apiFetch<Task[]>('/api/tasks'),
  complete:   (id: string)                   => apiFetch<void>(`/api/tasks/${id}/complete`,   { method: 'POST' }),
  reschedule: (id: string, when: string)     => apiFetch<void>(`/api/tasks/${id}/reschedule`,
    { method: 'POST', body: JSON.stringify({ when }) }),
  cancel:     (id: string)                   => apiFetch<void>(`/api/tasks/${id}/cancel`,     { method: 'POST' }),
};
